'use client';

import { RotateCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

interface SetupSessionRecoveryProps {
  onRestart: () => void;
  titleKey?: string;
  subtitleKey?: string;
  restartKey?: string;
}

export function SetupSessionRecovery({
  onRestart,
  titleKey = 'experience.recovery.title',
  subtitleKey = 'experience.recovery.subtitle',
  restartKey = 'experience.recovery.restart',
}: SetupSessionRecoveryProps) {
  const { t } = useTranslation('setup');

  return (
    <div className="relative mx-auto w-full max-w-[32rem] px-0 pb-10 pt-8 text-center">
      <h2 className="text-foreground mb-2 text-xl font-semibold">{t(titleKey)}</h2>
      <p className="text-muted-foreground m-0 text-[0.8125rem]">{t(subtitleKey)}</p>
      <Button type="button" className="mt-5" onClick={onRestart}>
        <RotateCcw className="size-4" aria-hidden />
        <span>{t(restartKey)}</span>
      </Button>
    </div>
  );
}
